var React = require('react');

function RightTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.2","d":"M1906 0L0 698H1906V0Z","fill":"url(#paintr_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paintr_linear","x1":"953","y1":"0","x2":"953","y2":"698","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#C4C4C4","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#C4C4C4","stopOpacity":"0","key":1})]))]);
}

RightTriangle.defaultProps = {"viewBox":"0 0 1906 698","fill":"none","preserveAspectRatio":"none"};

module.exports = RightTriangle;

RightTriangle.default = RightTriangle;
